import React, { useState, useEffect } from 'react';
import '../App.css';
import Swal from 'sweetalert2';
import logoUltra from './logoUtra.jpeg';

const NPSEstrela = () => {
  const [produtos, setProdutos] = useState(null);
  const [precos, setPrecos] = useState(null);
  const [promocoes, setPromocoes] = useState(null);
  const [atendimento, setAtendimento] = useState(null);
  const [idEmpresa, setIdEmpresa] = useState('');
  const [pdv, setPdv] = useState('');

  useEffect(() => {
    const id = localStorage.getItem('idEmpresa');
    const localPdv = localStorage.getItem('pdv');
    if (id) setIdEmpresa(id);
    if (localPdv) setPdv(localPdv);
  }, []);

  const getColor = (score) => {
    if (score <= 1) return "#e74c3c";
    if (score <= 2) return "#e67e22";
    if (score <= 3) return "#f1c40f";
    return "#2ecc71";
  };

  const renderStars = (selected, setSelected) => (
    <div className="score-container">
      {[1, 2, 3, 4, 5].map((score) => (
        <button
          key={score}
          className="score-button"
          style={{
            backgroundColor: getColor(score),
            border: selected === score ? "3px solid #000" : "none"
          }}
          onClick={() => setSelected(score)}
        >
          ⭐️
        </button>
      ))}
    </div>
  );

  const handleSave = async () => {
   

    try {
      const response = await fetch('https://fsys.app.br/5dx/npsLoja.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({
          id_empresa: idEmpresa,
          pc_enviado: pdv,
          encontrou_produtos: produtos,
          avaliacao_precos: precos,
          avaliacao_promocoes: promocoes,
          avaliacao_atendimento: atendimento
        }).toString(),
      });

      const data = await response.json();
      Swal.fire({
        icon: 'success',
        title: 'Obrigado!',
        text: 'Sua avaliação foi registrada com sucesso.',
        timer: 2000,
        showConfirmButton: false,
      });

      // Resetar
      setProdutos(null);
      setPrecos(null);
      setPromocoes(null);
      setAtendimento(null);
    } catch (error) {
      console.error("Erro ao salvar:", error);
      Swal.fire("Erro", "Não foi possível salvar. Tente novamente.", "error");
    }
  };
  const LinhaAvaliacao = ({ label, selected, setSelected }) => (
    <div className="linha-avaliacao">
      <h3 className="label">{label}</h3>
      <div className="estrelas">
        {[1, 2, 3, 4, 5].map((score) => (
          <span
            key={score}
            className="estrela"
            style={{
              color: score <= selected ? '#f1c40f' : '#ccc', // Dourado ou cinza
              fontSize: '70px',
              cursor: 'pointer',
              marginRight: 4,
            }}
            onClick={() => setSelected(score)}
          >
            {score <= selected ? '★' : '☆'}
          </span>
        ))}
      </div>
    </div>
  );
  
  
  return (
    <div className="container">
      <div style={{ textAlign: 'center' }}>
        <img src={logoUltra} alt="Logo Ultra" className="imgNpsLogo img-fluid" />
        <h2 style={{ marginTop: 10, fontWeight: 'bold' }}>Pesquisa de Satisfação</h2>
      </div>

      <div className="section-container">
        <div className="linha-avaliacao">
        <h3 style={{fontSize: 22, fontWeight: 'bold', maxWidth: '166px' }}>Encontrou o que procurava?</h3>
    <div className="estrelas">
      {[1, 2, 3, 4, 5].map((score) => (
        <span
          key={score}
          className="estrela"
          style={{
            color: score <= produtos ? '#f1c40f' : '#ccc',
            fontSize: '70px',
            cursor: 'pointer',
            marginRight: 4,
          }}
          onClick={() => setProdutos(score)}
        >
            {score <= produtos ? '★' : '☆'}
        </span>
      ))}
    </div>
  </div>
      </div>

      <div className="section-container">
        <h3 style={{fontSize: 22, fontWeight: 'bold' }}>Como você avalia o(a):</h3>
        <LinhaAvaliacao label="Preços:" selected={precos} setSelected={setPrecos} />
<LinhaAvaliacao label="Promoções:" selected={promocoes} setSelected={setPromocoes} />
<LinhaAvaliacao label="Atendimento:" selected={atendimento} setSelected={setAtendimento} />

      </div>

      <div className="button-container">
        <button className="submit-button" onClick={handleSave}>Enviar</button>
      </div>

    </div>
  );
};

export default NPSEstrela;
